<template>
    <div :class="[containerClass]">
<!--        <label v-if="label" :id="`input-${name}-label`" :for="`input${name}`" :class="[labelClass || 'form-label fs-6 fw-bolder', {isRequired: 'required'}]">
          <span v-if="attrs.level" class="me-2">{{ attrs.level }} - </span>{{ label }} &lt;!&ndash;<span v-if="isRequired" class="text-danger"> * </span>&ndash;&gt;
        </label>-->

      <div v-if="label" :class="{'required': isRequired}" class="h3 mb-5">
        <span v-if="attrs.level" class="">{{ attrs.level }} - </span>
        {{ label }}
      </div>
      <textarea
          class="form-control form-control-solid form-control-lg"
          :class="[inputClass, {resize: autoResizeBool}]"
          :name="name"
          :id="`textarea-${name}`"
          v-model="model"
          ref="textareaRef"
          :placeholder="placeholder"
          :required="isRequired"
          :rows="rows"
          @input="autoResize"
          style=""
      />
    </div>
  </template>
  
  <script setup>
  import {useAttrs, ref, watch} from "vue";

  const model = defineModel()

  const attrs = useAttrs()

  const textareaRef = ref(null)
  
  const props = defineProps( {
    name: String,
    placeholder: String,
    type: {type:String, default: "text"},
    rows: {type:Number, default: 6},
    isRequired: {type:Boolean, default: true},
    inputClass: String,
    labelClass: String,
    label: String,
    disabled: Boolean,
    autoResizeBool: {type:Boolean, default: false},
    containerClass: {
      type: String,
      default: 'col-12 mt-2 mb-3'
    },
  })

  function autoResize() {
    if(props.autoResizeBool) {
      const el = textareaRef.value
      if (el) {
        el.style.height = 'auto'
        el.style.height = el.scrollHeight + 'px'
      }
    }
  }

  watch(model.value, () => {
    if(props.autoResizeBool) {
      autoResize()
    }
  })
  
  </script>
  
  <style scoped>
    .resize {
      overflow:hidden;
      resize:none;
      width: 100%;
    }
  </style>